
$_GP.fileInput = function(elm) {
	elm = $(elm)
	if (!elm.length) return

	let $_ = $_GP.fn.dataNode(elm);

	const inputClone = $_.el('input').clone();

	const addInfo = function(str) {
		$_.el('name').text(str? str : '')
	};

	const addState = function() {
		$_.el('text-pick').removeClass('d-n');
		$_.el('text-change').addClass('d-n');
		$_.el('delete').addClass('d-n');
	};

	const removeState = function() {
		$_.el('text-pick').addClass('d-n');
		$_.el('text-change').removeClass('d-n');
		$_.el('delete').removeClass('d-n');
	};

	const reset = function() {
		// ie fix reset fileinput
		$_.el('input').remove();
		elm.prepend(inputClone);
		$_ = $_GP.fn.dataNode(elm);

		addInfo();
		addState();
	};

	const events = function() {

		elm.on('change', '[data-node-fileinput="input"]', function(ev) {
			if (this.files.length) {
				removeState();
				addInfo(this.files[0].name);
			} else {
				addState();
				addInfo();
			}
		});

		elm.on('click', '[data-node-fileinput="delete"]', function(ev) {
			ev.preventDefault();
			reset();
		});

		elm.on('focus', '[data-node-fileinput="input"]', function(ev) {
			elm.addClass('form-fileinput-focus');
		});

		elm.on('blur', '[data-node-fileinput="input"]', function(ev) {
			elm.removeClass('form-fileinput-focus');
		});
	};

	events();

	return {
		reset
	}
};
